import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
import { AccordionContext } from './accordion.context';
import { AccordionItemContext } from './accordionItem.context';
export const AccordionCollapseStyled = styled.div `
  padding-bottom: 0px;

  @media (min-width: ${breakpoints[1]}px) {
    padding-bottom: 12px;
  }
`;
export const AccordionCollapse = ({ children, ...rest }) => {
    const { disabled } = useContext(AccordionContext);
    const { open, itemDisabled } = useContext(AccordionItemContext);
    return itemDisabled || disabled || open ? (_jsx(AccordionCollapseStyled, { ...rest, children: typeof children === 'string' ? (_jsx("div", { dangerouslySetInnerHTML: { __html: children } })) : (children) })) : null;
};
//# sourceMappingURL=accordionCollapse.js.map